var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseRedCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0C8.08 0 0 8.08 0 18C0 27.92 8.08 36 18 36C27.92 36 36 27.92 36 18C36 8.08 27.92 0 18 0ZM18 33.54C9.42 33.54 2.46 26.56 2.46 18C2.46 9.44 9.44 2.46 18 2.46C26.56 2.46 33.54 9.44 33.54 18C33.54 26.56 26.56 33.54 18 33.54Z",
    fill: "#FF3434"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 24L18 18M18 18L12 12M18 18L24 12M18 18L12 24",
    stroke: "#FF3434",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseRedCircleIcon);
export default __webpack_public_path__ + "static/media/closeRedCircleIcon.935c3e33a6c53522a9bf3a3ca4a20c38.svg";
export { ForwardRef as ReactComponent };